export const ADDRESS_BOOKS_LIST_KEY = 'ADDRESS_BOOKS_LIST';
export const ADDRESS_BOOKS_ONE_KEY = 'ADDRESS_BOOKS_ONE_KEY';
